import { EncryptionService } from './encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from './exceptions-service';
import { GridColumnState } from 'src/app/core/interfaces/datagrid/grid-column-state';
import { HttpClientService } from './http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class GridColumnStateService {

  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public get(gridKey: string): Observable<GridColumnState[]> {
    try {
      return this.httpClientService.get<GridColumnState[]>(environment.eSimApi +
                                                           eSimApiPaths.GridColumnState + "/" +
                                                           encodeURIComponent(gridKey));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public reset(gridKey: string): Observable<any> {
    try {
      return this.httpClientService.delete(environment.eSimApi +
                                           eSimApiPaths.GridColumnState + "/" +
                                           encodeURIComponent(gridKey));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public save(gridKey: string, columns: GridColumnState[]): Observable<any> {
    try {
      const dto={ columns: columns, gridKey: gridKey };

      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(dto), true)
             .pipe(
               switchMap((encResult: StringResultDTO) => {
                 const objectEncSS=encResult.result;

                 return this.httpClientService.post(environment.eSimApi +
                                                    eSimApiPaths.GridColumnState +
                                                    "?objectEncSS=" + encodeURIComponent(objectEncSS), {});
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
